import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getVestingTermsSimplified } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';

export const useVestingTermsForDrawer = () => {
	const query = useQuery({
		queryKey: [API_PATHS.MIP_VESTING_TERM_NAMES_GET],
		queryFn: ({ signal }) =>
			getVestingTermsSimplified(API_PATHS.MIP_VESTING_TERM_NAMES_GET, signal),
	});

	return useMemo(
		() => (query.data?.payload ?? []).map((v) => ({ value: v.id, label: v.name })),
		[query.data]
	);
};
